// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.0-beta.493c8fd6d',
  revision: '493c8fd6d',
  branch: 'develop',
  date: 'Thu, 19 Mar 2026 16:05:13 GMT'
};